import React, { useState } from 'react';
import { HeaderHero } from './components/HeaderHero';
import { ProblemAgitation } from './components/ProblemAgitation';
import { ProductDetails } from './components/ProductDetails';
import { Offer } from './components/Offer';
import { BottomSection } from './components/BottomSection';
import { PlanId } from './components/PlanSelector';
import { PurchaseNotification } from './components/PurchaseNotification';
export function App() {
  const [selectedPlan, setSelectedPlan] = useState<PlanId>('megapack');
  return <div className="min-h-screen bg-slate-50 font-sans selection:bg-teal-200 selection:text-teal-900" data-id="element-0">
      <main data-id="element-1">
        <HeaderHero data-id="element-2" />
        <ProblemAgitation data-id="element-3" />
        <ProductDetails data-id="element-4" />
        <Offer selectedPlan={selectedPlan} onSelectPlan={setSelectedPlan} data-id="element-5" />
        <BottomSection selectedPlan={selectedPlan} onSelectPlan={setSelectedPlan} data-id="element-6" />
      </main>
      <PurchaseNotification data-id="element-7" />
    </div>;
}